<template>
  <PubPage showProject @changeProject="changeProject">
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="add('add')"
            >新增设备</a-button
          >
        </div>
      </template>
      <template slot="index" slot-scope="{ index }">
        {{ index + 1 }}
      </template>

      <template slot="supplierCode" slot-scope="{ record }">
        <PubStatus :status="record.supplierCode" type="DEVICE_SUPPLIER_CODE" />
      </template>
      <template slot="trafficDirection" slot-scope="{ record }">
        {{ record.trafficDirection | trafficDirectionFilter }}
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubStatus :status="record.status" type="FACE_DEVICE_STATUS" />
      </template>
      <template slot="place" slot-scope="{ record }">
        <PubStatus :status="record.place" type="FACE_DEVICE_PLACE" />
      </template>
      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <!-- <a @click="goPersonList(record)"><a-icon type="team" />查看学生</a> -->
          <a @click="add('edit', record)"><a-icon type="form" />编辑设备 </a>
          <a @click="deleteMachine(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddModal ref="addModalModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Equipment } from "@/api";
import AddModal from "./AddModal.vue";
export default {
  components: {
    AddModal,
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align: "center",
        width: 50,
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "设备品牌",
        dataIndex: "supplierCode",
        align: "center",
        scopedSlots: true,
      },
      {
        title: "设备名称",
        dataIndex: "name",
        align: "center",
      },
      {
        title: "序列号",
        dataIndex: "serialNumber",
        align: "center",
      },
      {
        title: "设备地点",
        dataIndex: "place",
        align: "center",
        scopedSlots: true,
      },
      {
        title: "通道方向",
        dataIndex: "trafficDirection",
        align: "center",
        hideInSearch: true,
        scopedSlots: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择通道方向",
          option: () => this.config.trafficDirection,
        },
      },
      {
        title: "设备状态",
        dataIndex: "status",
        align: "center",
        hideInSearch: true,
        scopedSlots: true,
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "options",
        hideInSearch: true,
        scopedSlots: true,
      },
    ];
    return {
      form: {
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      columns,
      projectInfo: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 切换学校
    changeProject() {
      this.form.schoolId = this.$store.state.user.schoolId;
      this.form.paging.page = 1;
      this.columns = [...this.columns];
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      Equipment.faceDeviceFindByPage(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },

    // 删除
    deleteMachine(id) {
      this.pubMsg.confirm("是否确定删除此设备？").then(() => {
        this.loading = true;
        Equipment.faceDeviceDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.loading = false;
            this.getList();
          }
        });
      });
    },
    add(type, data) {
      this.$refs.addModalModal.open(type, data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
    // 查看员工
    goPersonList(data) {
      this.$router.push({
        path: "/equipment/machineList/personList",
        query: {
          id: data.id,
          projectId: data.projectId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./style.less";
</style>
